

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_un338mqgj7 = () => {
                    
                        if (document.querySelector('.beae-e2uvzgg5:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-e2uvzgg5:not([data-beae-bind])'),
                                
                                id: 'beae-e2uvzgg5',
                                isLive: true
                            });
                            document.querySelector('.beae-e2uvzgg5:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-qw17iqbv:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-qw17iqbv:not([data-beae-bind])'),
                                
                                id: 'beae-qw17iqbv',
                                isLive: true
                            });
                            document.querySelector('.beae-qw17iqbv:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-u2scrfri:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-u2scrfri:not([data-beae-bind])'),
                                
                                id: 'beae-u2scrfri',
                                isLive: true
                            });
                            document.querySelector('.beae-u2scrfri:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_un338mqgj7()
                } else {
                    window.beaePageJS.push(jsHandle_un338mqgj7)
                }
            